import { css } from '@emotion/react';
import { useState } from 'react';
import { useNavPage } from '@/hooks/useNavPage';

const wrapper = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;
  padding: 56px 0;
  flex: 1;

  @media (max-width: 1169px) {
    padding: 48px 16px;
  }
`;

const header = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1140px;
  max-width: 100%;
`;

const tabs = css`
  display: flex;
  gap: 24px;
`;

const tab = css`
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 24px;
  line-height: 28.6px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
`;

const tabActive = css`
  ${tab};
  color: #241a17;
`;

const tabInactive = css`
  ${tab};
  color: rgba(61, 46, 41, 0.52);
`;

const actions = css`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const textButton = css`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 8px;
  border-radius: 6px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #251b18;
  &:hover {
    background: rgba(58, 58, 44, 0.06);
  }
`;

const newButton = css`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  height: 40px;
  padding: 0 17px;
  border: none;
  border-radius: 6px;
  background: #251b18;
  color: #f8f7f7;
  cursor: pointer;
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  &:hover {
    background: #2a2a28;
  }
  svg {
    color: #a39a97;
  }
`;

const card = css`
  display: flex;
  flex-direction: column;
  width: 1140px;
  max-width: 100%;
  background: #fff;
  border-radius: 10px;
  padding: 16px 32px 8px;
  box-shadow:
    0px 1px 1px -0.1px rgba(0, 0, 0, 0.05),
    0px 1.98px 3.06px -0.36px rgba(0, 0, 0, 0.05);
`;

const cardPlain = css`
  background: transparent;
  border-radius: 0;
  padding: 0;
  box-shadow: none;
`;

const tableRow = css`
  display: grid;
  grid-template-columns: 1fr 100px 100px 80px 80px 100px 100px;
  align-items: center;
  height: 80px;
  border-bottom: 1px solid rgba(60, 50, 47, 0.12);
  gap: 16px;
`;

const headerRow = css`
  display: grid;
  grid-template-columns: 1fr 100px 100px 80px 80px 100px 100px;
  align-items: center;
  height: 36px;
  gap: 16px;
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #241a17;
`;

const productCell = css`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const thumbnail = css`
  width: 48px;
  height: 48px;
  border-radius: 6px;
  object-fit: cover;
  background: #d4cfce;
`;

const productName = css`
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #241a17;
`;

const cellText = css`
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #241a17;
`;

const mutedText = css`
  ${cellText};
  color: rgba(57, 48, 45, 0.52);
`;

const badgeBase = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  padding: 0 12px;
  border-radius: 112px;
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 12px;
  white-space: nowrap;
`;

const badgeActive = css`
  ${badgeBase};
  background: #dcf2cf;
  color: #1f4002;
`;

const badgeDraft = css`
  ${badgeBase};
  background: transparent;
  color: rgba(61, 46, 41, 0.52);
  border: 1px solid rgba(55, 49, 47, 0.2);
`;

const badgePublished = css`
  ${badgeBase};
  background: #dcf2cf;
  color: #1f4002;
`;

const iconButton = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 6px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: rgba(61, 46, 41, 0.52);
  &:hover {
    background: rgba(58, 58, 44, 0.06);
  }
`;

const rowActions = css`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
`;

const products = [
  {
    name: 'Custom Itinerary',
    image: '/images/emails/email-1.png',
    status: 'active',
    price: '$15',
    stock: '∞',
    sold: 412,
    sales: '$6,518',
  },
  {
    name: 'Custom itinerary plus',
    image: '/images/emails/email-2.png',
    status: 'active',
    price: '$20/mo',
    stock: 50,
    sold: 22,
    sales: '$9,990',
  },
  {
    name: 'the DIY Portugal Bundle',
    image: '/images/emails/email-3.png',
    status: 'active',
    price: '$27',
    stock: '∞',
    sold: 1055,
    sales: '$28,485',
  },
  {
    name: '30 EXTRA MINUTES to chat about your trip',
    image: '/images/emails/email-4.png',
    status: 'active',
    price: '$50',
    stock: 8,
    sold: 8,
    sales: '$400',
  },
  {
    name: 'the DIY Marrakech Bundle',
    image: '/images/emails/email-5.png',
    status: 'draft',
    price: '$24',
    stock: '∞',
    sold: 0,
    sales: '0',
  },
  {
    name: 'Gourmet Food Tour',
    image: '/images/emails/email-6.png',
    status: 'published',
    price: '$50',
    stock: 8,
    sold: 8,
    sales: '$400',
  },
  {
    name: 'Adventure Hiking Package',
    image: '/images/emails/email-1.png',
    status: 'active',
    price: '$50',
    stock: 8,
    sold: 8,
    sales: '$400',
  },
  {
    name: 'Luxury Spa Retreat',
    image: '/images/emails/email-2.png',
    status: 'active',
    price: '$50',
    stock: 8,
    sold: 8,
    sales: '$400',
  },
];

function getBadge(status: string) {
  if (status === 'draft') return badgeDraft;
  if (status === 'published') return badgePublished;
  return badgeActive;
}

function getStatusLabel(status: string) {
  if (status === 'draft') return 'Draft';
  if (status === 'published') return 'Published';
  return 'Active';
}

export default function ProductsView() {
  const [, setNavPage] = useNavPage();
  const [muteDraft] = useState(true);
  const [hasBackground, setHasBackground] = useState(true);

  return (
    <div css={wrapper}>
      <div css={header}>
        <div css={tabs}>
          <button css={tabActive} type="button">
            My products
          </button>
          <button css={tabInactive} type="button" onClick={() => setNavPage('discounts')}>
            Discounts
          </button>
        </div>
        <div css={actions}>
          <button css={textButton} type="button">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <circle cx="7.5" cy="7.5" r="6" stroke="currentColor" strokeWidth="1.5" />
              <path
                d="M12 12L16.5 16.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
            Search
          </button>
          <button css={textButton} type="button">
            Sort
            <svg width="10" height="18" viewBox="0 0 10 18" fill="none">
              <path
                d="M1 7L5 11L9 7"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <button css={textButton} type="button">
            Status
            <svg width="10" height="18" viewBox="0 0 10 18" fill="none">
              <path
                d="M1 7L5 11L9 7"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <button css={newButton} type="button" onClick={() => setHasBackground(prev => !prev)}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path
                d="M7 1V13M1 7H13"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
            New product
          </button>
        </div>
      </div>

      <div css={[card, !hasBackground && cardPlain]}>
        <div css={headerRow}>
          <div>Product</div>
          <div>Status</div>
          <div>Price</div>
          <div>Stock</div>
          <div>Sold</div>
          <div>Total sales</div>
          <div />
        </div>
        {products.map(p => {
          const isDraft = p.status === 'draft';
          return (
            <div key={p.name} css={tableRow}>
              <div css={productCell}>
                <img css={thumbnail} src={p.image} alt="" />
                <span css={productName}>{p.name}</span>
              </div>
              <div>
                <span css={getBadge(p.status)}>{getStatusLabel(p.status)}</span>
              </div>
              <div css={isDraft && muteDraft ? mutedText : cellText}>{p.price}</div>
              <div css={isDraft && muteDraft ? mutedText : cellText}>{p.stock}</div>
              <div css={isDraft && muteDraft ? mutedText : cellText}>{p.sold}</div>
              <div css={isDraft && muteDraft ? mutedText : cellText}>{p.sales}</div>
              <div css={rowActions}>
                <button css={iconButton} type="button" aria-label="Analytics">
                  <svg width="12" height="17" viewBox="0 0 12 17" fill="none">
                    <path
                      d="M1.5 16.25C1.5 16.6642 1.16421 17 0.75 17C0.335787 17 0 16.6642 0 16.25L0 10.25C0 9.83579 0.335786 9.5 0.75 9.5C1.16421 9.5 1.5 9.83579 1.5 10.25L1.5 16.25ZM6.75 16.25C6.75 16.6642 6.41421 17 6 17C5.58579 17 5.25 16.6642 5.25 16.25L5.25 0.75C5.25 0.335786 5.58579 0 6 0C6.41421 0 6.75 0.335786 6.75 0.75L6.75 16.25ZM12 16.25C12 16.6642 11.6642 17 11.25 17C10.8358 17 10.5 16.6642 10.5 16.25L10.5 4.25293C10.5 3.83872 10.8358 3.50293 11.25 3.50293C11.6642 3.50293 12 3.83872 12 4.25293L12 16.25Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
                <button css={iconButton} type="button" aria-label="More">
                  <svg width="15" height="18" viewBox="0 0 15 18" fill="none">
                    <circle cx="2" cy="9" r="1.5" fill="currentColor" />
                    <circle cx="7.5" cy="9" r="1.5" fill="currentColor" />
                    <circle cx="13" cy="9" r="1.5" fill="currentColor" />
                  </svg>
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
